import { Link } from "react-router-dom";

// material-ui
import ButtonBase from "@mui/material/ButtonBase";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// project imports
import Logo from "uicomponent/Logo";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  return (
    <ButtonBase disableRipple component={Link} to={"/"}>
      <Logo size="small" />{" "}
      <Box component="span" sx={{ ml: 1.2 }}>
        <Typography variant="h4">FRACTIONAL.TOOLS</Typography>
      </Box>
    </ButtonBase>
  );
};

export default LogoSection;
